export default __webpack_public_path__ + "static/media/white-logo.24ef8984.png";